import React from "react";
import { loginWithGoogle } from "../lib/auth";
import { Button } from "../components/ui/button";
import { LogIn, ShieldCheck, FileText, MapPin } from "lucide-react";

export default function LoginPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/40 to-white flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="pac-card p-8 bg-grain relative overflow-hidden">
          <div className="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-blue-500 to-indigo-600" />

          <div className="flex items-center gap-2 mb-3 flex-wrap">
            <span className="pac-pill bg-emerald-100 text-emerald-800 inline-flex items-center gap-1">
              <ShieldCheck className="h-3 w-3" />
              Accès sécurisé
            </span>
          </div>

          <h1 className="font-display text-3xl font-bold text-slate-900 leading-tight">
            GSCE&nbsp;France
          </h1>
          <p className="mt-1 text-sm text-slate-500">
            Dimensionnement professionnel — pompes à chaleur Air/Eau
          </p>

          <p className="mt-6 text-slate-700 text-sm">
            Connectez-vous pour accéder à vos notes de dimensionnement et générer
            vos rapports PDF&nbsp;:
          </p>

          <ul className="mt-4 space-y-2 text-sm text-slate-600">
            <li className="flex items-center gap-2">
              <FileText className="h-4 w-4 text-blue-500 flex-shrink-0" />
              Sauvegarde sécurisée de vos projets
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-blue-500 flex-shrink-0" />
              Accès depuis n'importe quel appareil
            </li>
            <li className="flex items-center gap-2">
              <ShieldCheck className="h-4 w-4 text-emerald-500 flex-shrink-0" />
              Vos données restent privées
            </li>
          </ul>

          <Button
            onClick={() => loginWithGoogle()}
            className="mt-7 w-full h-12 bg-[#3b82f6] hover:bg-blue-600 text-white rounded-xl text-base shadow-sm"
            data-testid="login-with-google"
          >
            <LogIn className="h-5 w-5 mr-2" />
            Continuer avec Google
          </Button>

          <p className="mt-4 text-[11px] text-slate-400 text-center">
            En vous connectant, vous acceptez l'utilisation de cookies de session
            (durée 7 jours).
          </p>
        </div>
      </div>
    </div>
  );
}
